import React, { useState } from 'react';
import Fretboard from 'react-fretboard'
import { Chord } from "@tonaljs/tonal";
import { Key } from "@tonaljs/tonal";
import Select from 'react-select';
import chroma from 'chroma-js';
import romanify from 'romanify';
import './App.css'

function App() {
  const tonics = [
    { value: 'A', label: 'A' },
    { value: 'A#', label: 'A#'},
    { value: 'B', label: 'B'},
    { value: 'C', label: 'C'},
    { value: 'C#', label: 'C#'},
    { value: 'D', label: 'D'},
    { value: 'D#', label: 'D#'},
    { value: 'E', label: 'E'},
    { value: 'F', label: 'F'},
    { value: 'F#', label: 'F#'},
    { value: 'G', label: 'G' },
    { value: 'G#', label: 'G#'}
  ];
  const colorMap = [
    chroma('#FF2200').desaturate(2).hex(),
    chroma('#FFA600').desaturate(2).hex(),
    chroma('#F3FC02').desaturate(2).hex(),
    chroma('#17B92A').desaturate(2).hex(),
    chroma('#00EAE8').desaturate(2).hex(),
    chroma('#0037A8').desaturate(2).hex(),
    chroma('#932CE2').desaturate(2).hex(), 
  ]
  const negativeColorMap = [
    chroma('#FF2200').darken().desaturate(2).hex(),
    chroma('#FFA600').darken().desaturate(2).hex(),
    chroma('#F3FC02').darken().desaturate(2).hex(),
    chroma('#17B92A').darken().desaturate(2).hex(),
    chroma('#00EAE8').darken().desaturate(2).hex(),
    chroma('#0037A8').darken().desaturate(2).hex(),
    chroma('#932CE2').darken().desaturate(2).hex(), 
  ]

  const scaleKeys = [
    { value: 'major', label: 'major' },
    { value: 'minor', label: 'minor' },
  ];
  const voicings = [
    { value: 'standard', label: 'Standard (1,3,5)' },
    { value: 'shell', label: 'Shell (1,3,7)' },
    { value: 'full', label: 'Full (1,3,5,7)' },
  ]
  const [currentScale, setCurrentScale] = useState({
    tonic: { value: null, label: 'Tonic'},
    scaleKey: { value: null, label: 'Key' }
  });
  const [currentChords, setCurrentChords] = useState(null);
  const [currentNegativeChords, setCurrentNegativeChords] = useState(null);
  const [currentScaleIntervals, setCurrentScaleIntervals] = useState(null);
  const [currentNegativeScaleIntervals, setCurrentNegativeScaleIntervals] = useState(null);
  const [displayScaleTones, setDisplayScaleTones] = useState(false);
  const [currentKey, setCurrentKey] = useState(null);
  const [zoom, setZoom] = useState(3);
  const [voicing, setVoicing] = useState(voicings[0])
  const updateZoom = (cmd) => {
    if (cmd === 1 && zoom < 3) {
      setZoom(zoom + 1);
    }
    if (cmd === -1 && zoom > 1) {
      setZoom(zoom - 1);
    }
  }
  const updateKey = (tonic, scaleKey, voicing) => {
    if (scaleKey === 'major') {
      const key = Key.majorKey(tonic);
      const negativeKey = Key.minorKey(tonic);
      setCurrentKey(key);
      let notes;
      let intervals;
      let negativeNotes;
      let negativeIntervals;
      if (voicing.value === 'standard') {
        notes = key.chords.map(chord => Chord.get(chord).notes.slice(0,3));
        intervals = notes.map(chord => chord.map(note => key.intervals[key.scale.indexOf(note)]));
        negativeNotes = negativeKey.natural.chords.map(chord => Chord.get(chord).notes.slice(0,3));
        negativeIntervals = negativeNotes.map(chord => chord.map(note => negativeKey.natural.intervals[negativeKey.natural.scale.indexOf(note)]));
      }
      if (voicing.value === 'shell') {
        notes = key.chords.map(chord => Chord.get(chord).notes);
        intervals = notes.map(chord => chord.map(note => key.intervals[key.scale.indexOf(note)]));
        notes = notes.map(chord => chord.filter((note, index) => index !== 2));
        intervals = intervals.map(chord => chord.filter((note, index) => index !== 2));
        negativeNotes = negativeKey.natural.chords.map(chord => Chord.get(chord).notes);
        negativeIntervals = negativeNotes.map(chord => chord.map(note => negativeKey.natural.intervals[negativeKey.natural.scale.indexOf(note)]));
        negativeNotes = negativeNotes.map(chord => chord.filter((note, index) => index !== 2));
        negativeIntervals = negativeIntervals.map(chord => chord.filter((note, index) => index !== 2));
      }
      if (voicing.value === 'full') {
        notes = key.chords.map(chord => Chord.get(chord).notes);
        intervals = notes.map(chord => chord.map(note => key.intervals[key.scale.indexOf(note)]));
        negativeNotes = negativeKey.natural.chords.map(chord => Chord.get(chord).notes);
        negativeIntervals = negativeNotes.map(chord => chord.map(note => negativeKey.natural.intervals[negativeKey.natural.scale.indexOf(note)]));
      }
      setCurrentChords(key.chords.map((chord, index) => { return {
          chordName: chord,
          notes: notes[index],
          intervals: intervals[index],
          enabled: currentChords ? currentChords[index].enabled : true,
      } }))
      setCurrentNegativeChords(negativeKey.natural.chords.map((chord, index) => { return {
          chordName: chord,
          notes: negativeNotes[index],
          intervals: negativeIntervals[index],
          enabled: currentNegativeChords ? currentNegativeChords[index].enabled : false
      } }))

      setCurrentScaleIntervals(key.intervals);
      setCurrentNegativeScaleIntervals(negativeKey.natural.intervals);
    }
    if (scaleKey === 'minor') {
      const key = Key.minorKey(tonic);
      const negativeKey = Key.majorKey(tonic);
      setCurrentKey(key);
      let notes;
      let intervals;
      let negativeNotes;
      let negativeIntervals;
      if (voicing.value === 'standard') {
        notes = key.natural.chords.map(chord => Chord.get(chord).notes.slice(0,3));
        intervals = notes.map(chord => chord.map(note => key.natural.intervals[key.natural.scale.indexOf(note)]));
        negativeNotes = negativeKey.chords.map(chord => Chord.get(chord).notes.slice(0,3));
        negativeIntervals = negativeNotes.map(chord => chord.map(note => negativeKey.intervals[negativeKey.scale.indexOf(note)]));
      }
      if (voicing.value === 'shell') {
        notes = key.natural.chords.map(chord => Chord.get(chord).notes);
        intervals = notes.map(chord => chord.map(note => key.natural.intervals[key.natural.scale.indexOf(note)]));
        notes = notes.map(chord => chord.filter((note, index) => index !== 2));
        intervals = intervals.map(chord => chord.filter((note, index) => index !== 2));
        negativeNotes = negativeKey.chords.map(chord => Chord.get(chord).notes);
        negativeIntervals = negativeNotes.map(chord => chord.map(note => negativeKey.intervals[negativeKey.scale.indexOf(note)]));
        negativeNotes = negativeNotes.map(chord => chord.filter((note, index) => index !== 2));
        negativeIntervals = negativeIntervals.map(chord => chord.filter((note, index) => index !== 2));
      }
      if (voicing.value === 'full') {
        notes = key.natural.chords.map(chord => Chord.get(chord).notes);
        intervals = notes.map(chord => chord.map(note => key.natural.intervals[key.natural.scale.indexOf(note)]));
        negativeNotes = negativeKey.chords.map(chord => Chord.get(chord).notes);
        negativeIntervals = negativeNotes.map(chord => chord.map(note => negativeKey.intervals[negativeKey.scale.indexOf(note)]));
      }
      setCurrentChords(key.natural.chords.map((chord, index) => { return {
          chordName: chord,
          notes: notes[index],
          intervals: intervals[index],
          enabled: currentChords ? currentChords[index].enabled : true,
      } }))
      setCurrentNegativeChords(negativeKey.chords.map((chord, index) => { return {
          chordName: chord,
          notes: negativeNotes[index],
          intervals: negativeIntervals[index],
          enabled: currentNegativeChords ? currentNegativeChords[index].enabled : false
      } }))
      setCurrentScaleIntervals(key.natural.intervals);
      setCurrentNegativeScaleIntervals(negativeKey.intervals);
    }
  }
  return (
    <div className="app">
      <h2>Porkloin's Guitar Triad Practice Tool Mk2 (aka PGTPTMk2™)</h2>
      <a href="https://porkloin.github.io/progression-roulette-mk2/">Go to Progression Roulette Tool</a>
      <div
        className="controls"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '70vw',
          width: '100%',
          margin: '0',
        }}
      >
        <div style={{
          flexBasis:'200px',
          minWidth: '200px',
          margin: '0 1em',
        }}>
          <span style={{ fontSize: '0.8rem' }}>Tonic:</span>
          <Select
            options={tonics}
            value={currentScale.tonic}
            placeholder={'Tonic'}
            onChange={async(selectedOption) => {
              setCurrentScale({tonic: selectedOption, scaleKey: currentScale.scaleKey})
              if (currentScale.scaleKey.value !== null) {
                updateKey(selectedOption.value, currentScale.scaleKey.value, voicing);
              }
            }}
          />
        </div>
        <div style={{
          flexBasis:'200px',
          minWidth: '200px',
          margin: '0 1em',
        }}>
          <span style={{ fontSize: '0.8rem' }}>Key:</span>
          <Select
            options={scaleKeys}
            value={currentScale.scaleKey}
            placeholder={'Key'}
            onChange={async(selectedOption) => {
              setCurrentScale({tonic: currentScale.tonic, scaleKey: selectedOption})
              if (currentScale.tonic.value !== null) {
                updateKey(currentScale.tonic.value, selectedOption.value, voicing);
              }
            }}
          />
        </div>
        <div style={{
          flexBasis:'200px',
          minWidth: '200px',
          margin: '0 1em',
        }}>
          <span style={{ fontSize: '0.8rem' }}>Voicing:</span>
          <Select
            options={voicings}
            value={voicing}
            placeholder={'Voicing'}
            onChange={async(selectedOption) => {
              await setVoicing(selectedOption)
              if (currentScale.tonic.value !== null && currentScale.scaleKey.value !== null) {
                await updateKey(currentScale.tonic.value, currentScale.scaleKey.value, selectedOption);
              }
            }}
          />
        </div>
        <div style={{
          flexBasis:'200px',
          minWidth: '200px',
          margin: '0 1em',
        }}>
          <div style={{
            marginBottom: '1.1em',
            fontSize: '0.8rem'
          }}>
            Zoom:
          </div>
          <div>
            <span
              className="zoomControls"
              onClick={(e) => {
                e.preventDefault();
                updateZoom(-1);
              }}
            >
              -
            </span>
              {zoom}
            <span
              className="zoomControls"
              onClick={(e) => {
                e.preventDefault();
                updateZoom(1);
              }}
            >
              +
            </span>
          </div>
        </div>
        <div style={{
          flexBasis:'200px',
          minWidth: '200px',
          margin: '0 1em',
        }}>
          <div style={{
            marginBottom: '1.1em',
            fontSize: '0.8rem'
          }}>
            Display Scale Tones:
          </div>
          <div>
            <input
              className="scaleTones"
              type="checkbox"
              checked={!!displayScaleTones}
              onClick={(e) => {
                setDisplayScaleTones(!displayScaleTones);
              }}
            />
          </div>
        </div>
      </div>
      { currentChords &&
        <>
        <div style={{
          marginTop: '0.5em',
          marginBottom: '0.25em',
          fontSize: '0.8rem'
        }}>
          Toggle Chords:
        </div>
        <div
          className="controls"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '100%',
            width: '100%',
            margin: '0 auto',
          }}
        >
          {currentChords.map((chord, index) => {
              return (
                <div
                  key={chord.notes.join("")}
                  style={{
                    padding: '0.5em 0.5em',
                    margin: '0.25em 0.5em 0',
                    flexBasis: '150px',
                    whiteSpace: 'nowrap',
                    border: '1px solid black',
                    borderRadius: '0.25em',
                    background: chord.enabled ? colorMap[index] : '#333',
                    color: chord.enabled ? 'black' : '#777',
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    let chords = currentChords.map((item) => {
                      if (item.chordName === chord.chordName) {
                        item.enabled = !item.enabled;
                        return item;
                      }
                      else {
                        return item;
                      }
                    });
                    setCurrentChords(chords);
                  }}
                >
                  {romanify(index + 1)} - {chord.chordName}
                </div>
              )
            })
          }
        </div>
        <div style={{
          marginTop: '0.5em',
          marginBottom: '0.25em',
          fontSize: '0.8rem'
        }}>
          Shadow Realm:
        </div>
        <div
          className="controls"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '100%',
            width: '100%',
            margin: '0 auto',
          }}
        >
          {currentNegativeChords.map((chord, index) => {
              return (
                <div
                  key={chord.notes.join("")}
                  style={{
                    padding: '0.5em 0.5em',
                    margin: '0.25em 0.5em 0',
                    flexBasis: '150px',
                    whiteSpace: 'nowrap',
                    border: '1px solid black',
                    borderRadius: '0.25em',
                    background: chord.enabled ? negativeColorMap[index] : '#333',
                    color: chord.enabled ? 'black' : '#777',
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    let chords = currentNegativeChords.map((item) => {
                      if (item.chordName === chord.chordName) {
                        item.enabled = !item.enabled;
                        return item;
                      }
                      else {
                        return item;
                      }
                    });
                    setCurrentNegativeChords(chords);
                  }}
                >
                  {romanify(index + 1)} - {chord.chordName}
                </div>
              )
            })
          }
          </div>
          <div
            className={"fretboards zoomLevel" + zoom}
          >
          {currentChords.map((chord, index) => {
            if (chord.enabled) {
              return (
                <div
                  key={chord.notes.join("")}
                  className="fretboard"
                  style={{
                    order: index
                  }}
                >
                  <h4 style={{textAlign: 'center'}}>{romanify(index + 1)}: {chord.chordName} - {chord.notes.join(" ")}</h4>
                <Fretboard
                  skinType="boxes"
                  nrOfFrets={15}
                  selectedNotes={chord.notes.map((note, index) => {
                    return {
                      note: note,
                      label: note + '/' + chord.intervals[index],
                      status: chord.intervals[index]
                    }
                  }).concat(displayScaleTones
                    ? currentKey.scale.map((note, index) => {
                      return {
                        note: note,
                        label: note + '/' + currentScaleIntervals[index],
                        status: "scaleTone"
                      }
                    }).filter(note => !chord.notes.includes(note.note)) : [])
                  }
                  theme={{ statusMap: Object.assign({scaleTone: "DimGrey"}, ...currentScaleIntervals.map((n, index) => ({[n]: colorMap[index]}))) }}
                />
                </div>
              )
            }
            else {
              return null
            }
          })}
          <br />
          {currentNegativeChords.map((chord, index) => {
            if (chord.enabled) {
              return (
                <div
                  key={chord.notes.join("")}
                  className="fretboard"
                  style={{
                    order: index
                  }}
                >
                  <h4 style={{textAlign: 'center'}}>Shadow {romanify(index + 1)}: {chord.chordName} - {chord.notes.join(" ")}</h4>
                <Fretboard
                  skinType="boxes"
                  nrOfFrets={15}
                  selectedNotes={chord.notes.map((note, index) => {
                    return {
                      note: note,
                      label: note + '/' + chord.intervals[index],
                      status: chord.intervals[index]
                    }
                  }).concat(displayScaleTones
                    ? currentKey.scale.map((note, index) => {
                      return {
                        note: note,
                        label: note + '/' + currentScaleIntervals[index],
                        status: "scaleTone"
                      }
                    }).filter(note => !chord.notes.includes(note.note)) : [])
                  }
                  theme={{ statusMap: Object.assign({scaleTone: "DimGrey"}, ...currentNegativeScaleIntervals.map((n, index) => ({[n]: negativeColorMap[index]}))) }}
                />
                </div>
              )
            }
            else {
              return null
            }
          })}
          </div>
        </>
      }
    </div>
  );
}

export default App;
